function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#F5A623",
  d: "M16.847 18.896c-.056.25-.101.447-.14.604h-5.366c-.034-.158-.07-.326-.091-.434a22.312 22.312 0 00-2.048-5.82 14.955 14.955 0 00-.424-.838l-.157-.292a7.556 7.556 0 01-1.081-3.15 6.864 6.864 0 011.395-4.948c1.097-1.395 2.68-2.282 4.403-2.468l.01-.001c2.708-.343 5.33 1.141 6.512 3.681A8.183 8.183 0 0120.48 9a9.301 9.301 0 01-1.34 3.614c-.4.72-.763 1.463-1.089 2.23a24.816 24.816 0 00-1.19 3.727l-.014.115v.21zM13.227.556l-.005.001.009-.001h-.005z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#979797",
  strokeLinecap: "square",
  d: "M13 25.5h2m-3.5-2h5m-5-2h5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F5A623",
  strokeLinecap: "square",
  d: "M21.5 13.5l5 3m0-16l-5 3m1.5 5h4M6.5 13.5l-5 3M1.5.5l5 3M5 8.5H1"
}));

function SvgLightBulbTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbTip);
export default __webpack_public_path__ + "static/media/LightBulbTip.c4ffc854.svg";
export { ForwardRef as ReactComponent };